import { render, staticRenderFns } from "./TableUserBasic.vue?vue&type=template&id=9c0dc8c2&"
import script from "./TableUserBasic.vue?vue&type=script&lang=js&"
export * from "./TableUserBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports